<template>
  <v-list-item-group
    :value="value"
    @change="$emit('input', $event)"
  >
    <v-list-item
      v-for="item of businessNames"
      :key="item.searchId"
    >
      <template v-slot:default="{ active }">
        <v-list-item-action>
          <v-checkbox :input-value="active"></v-checkbox>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>{{ item.businessName }}</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                :href="getDetailsUrl(item)"
                rel="noopener noreferrer"
                target="_blank"
              >
                <v-icon color="grey lighten-1">help</v-icon>
              </v-btn>
            </template>
            <span>Click to check details in ASIC</span>
          </v-tooltip>
        </v-list-item-action>
      </template>
    </v-list-item>
  </v-list-item-group>
</template>

<script>
export default {
  name: 'BusinessNameList',

  props: {
    value: {
      type: Number
    },
    businessNames: {
      type: Array,
      required: true
    }
  },

  methods: {
    getDetailsUrl (item) {
      const url = new URL('https://connectonline.asic.gov.au/RegistrySearch/faces/landing/bySearchId.jspx')
      url.searchParams.set('searchIdType', item.searchIdType)
      url.searchParams.set('searchId', item.searchId)
      return url.toString()
    }
  }
}
</script>
